<template>
  <section class="section section-openclaw">
    <div class="tech-bg">
      <div class="grid-overlay"></div>
      <div class="floating-particles">
        <div class="particle" v-for="n in 30" :key="n" :style="particleStyle(n)"></div>
      </div>
      <div class="glow-orb glow-orb-1"></div>
      <div class="glow-orb glow-orb-2"></div>
      <div class="glow-orb glow-orb-3"></div>
      <div class="hex-grid"></div>
    </div>
    <div class="container">
      <div class="page-head">
        <h2>OpenClaw 自动化工具</h2>
        <p>电脑自动化操作，解放双手，批量处理任务</p>
      </div>
      <div class="card">
        <div class="intro-section">
          <p class="intro-text">
            OpenClaw 是一款强大的自动化工具，帮助您实现电脑操作的自动化，解放双手，提高工作效率。
            无论是批量操作、定时任务还是复杂的工作流程，OpenClaw 都能轻松应对。
          </p>
        </div>
        
        <div class="download-section">
          <h3>免费下载</h3>
          <div class="download-cards">
            <div class="download-card">
              <div class="download-icon windows">🖥️</div>
              <h4>Windows</h4>
              <p>支持 Windows 10/11</p>
              <button class="btn primary" v-for="download in downloads.windows" :key="download.id" @click="handleDownload(download.id, download.download_url)">
                {{ download.version }} - 立即下载
              </button>
            </div>
            <div class="download-card">
              <div class="download-icon mac">🍎</div>
              <h4>Mac</h4>
              <p>支持 macOS 10.15+</p>
              <button class="btn primary" v-for="download in downloads.macos" :key="download.id" @click="handleDownload(download.id, download.download_url)">
                {{ download.version }} - 立即下载
              </button>
            </div>
            <div class="download-card">
              <div class="download-icon linux">🐧</div>
              <h4>Linux</h4>
              <p>支持 Ubuntu/Debian</p>
              <button class="btn primary" v-for="download in downloads.linux" :key="download.id" @click="handleDownload(download.id, download.download_url)">
                {{ download.version }} - 立即下载
              </button>
            </div>
          </div>
        </div>
        
        <div class="features-section">
          <h3>核心功能</h3>
          <div class="features-grid">
            <div class="feature-item">
              <div class="feature-icon">🎯</div>
              <h4>鼠标键盘自动化</h4>
              <p>录制和回放鼠标键盘操作，实现自动化流程</p>
            </div>
            <div class="feature-item">
              <div class="feature-icon">⚡</div>
              <h4>批量处理</h4>
              <p>批量打开软件、网页、文件，提高工作效率</p>
            </div>
            <div class="feature-item">
              <div class="feature-icon">💬</div>
              <h4>自动互动</h4>
              <p>自动发私信、评论、互动，节省时间</p>
            </div>
            <div class="feature-item">
              <div class="feature-icon">⏰</div>
              <h4>定时任务</h4>
              <p>设置定时任务，循环执行，无需人工干预</p>
            </div>
            <div class="feature-item">
              <div class="feature-icon">🧩</div>
              <h4>可视化编辑</h4>
              <p>可视化流程编辑，无需编程知识</p>
            </div>
            <div class="feature-item">
              <div class="feature-icon">🔌</div>
              <h4>插件扩展</h4>
              <p>支持插件扩展，功能不断丰富</p>
            </div>
          </div>
        </div>
        
        <div class="membership-section">
          <div class="membership-card">
            <h3>会员专属服务</h3>
            <p class="membership-text">
              如果您需要我们专业为您培养龙虾让智能体更懂您，让智能体配合您完成您的工作，而不是简单的会话聊天烧Token，就请加入我们的会员，我们将为您打造专属的龙虾技能培训服务。
            </p>
            <button class="btn primary" @click="$router.push('/price')">了解会员详情</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { authMixin } from '../utils/authMixin'

export default {
  name: 'OpenClaw',
  mixins: [authMixin],
  data() {
    return {
      downloads: {
        windows: [],
        macos: [],
        linux: []
      }
    }
  },
  mounted() {
    this.getDownloads()
  },
  methods: {
    particleStyle() {
      const size = Math.random() * 4 + 1
      const left = Math.random() * 100
      const top = Math.random() * 100
      const duration = Math.random() * 20 + 10
      const delay = Math.random() * 10
      return {
        width: `${size}px`,
        height: `${size}px`,
        left: `${left}%`,
        top: `${top}%`,
        animationDuration: `${duration}s`,
        animationDelay: `${delay}s`
      }
    },
    getDownloads() {
      this.$axios.get('/api/downloads')
        .then(response => {
          if (response.data.code === 200) {
            this.downloads = response.data.data
          }
        })
        .catch(error => {
          console.error('获取下载链接失败:', error)
        })
    },
    handleDownload(id, url) {
      // 记录下载次数
      this.$axios.post(`/api/downloads/${id}/count`)
        .then(() => {
          console.log('下载次数已更新')
        })
        .catch(error => {
          console.error('更新下载次数失败:', error)
        })
      
      // 打开下载链接
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.section-openclaw {
  padding-top: 100px;
  background: linear-gradient(180deg, #0a0e1a 0%, #0d1224 50%, #0a0e1a 100%);
  position: relative;
  min-height: 100vh;
}

.tech-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.grid-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(0, 230, 172, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 230, 172, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: gridMove 20s linear infinite;
}

@keyframes gridMove {
  0% { transform: translate(0, 0); }
  100% { transform: translate(50px, 50px); }
}

.floating-particles {
  position: absolute;
  width: 100%;
  height: 100%;
}

.particle {
  position: absolute;
  background: rgba(0, 230, 172, 0.4);
  border-radius: 50%;
  animation: floatParticle linear infinite;
  filter: blur(1px);
  box-shadow: 0 0 8px rgba(0, 230, 172, 0.3);
}

@keyframes floatParticle {
  0% { transform: translateY(0) translateX(0); opacity: 0; }
  10% { opacity: 1; }
  90% { opacity: 1; }
  100% { transform: translateY(-100vh) translateX(50px); opacity: 0; }
}

.glow-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.15;
}

.glow-orb-1 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(0, 204, 153, 0.6) 0%, transparent 70%);
  top: 20%;
  left: 10%;
  animation: floatOrb1 15s ease-in-out infinite;
}

.glow-orb-2 {
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(0, 230, 172, 0.6) 0%, transparent 70%);
  top: 50%;
  right: 15%;
  animation: floatOrb2 18s ease-in-out infinite;
}

.glow-orb-3 {
  width: 350px;
  height: 350px;
  background: radial-gradient(circle, rgba(79, 172, 254, 0.6) 0%, transparent 70%);
  bottom: 10%;
  left: 50%;
  animation: floatOrb3 20s ease-in-out infinite;
}

@keyframes floatOrb1 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(100px, -50px); }
}

@keyframes floatOrb2 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(-80px, 80px); }
}

@keyframes floatOrb3 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(-60px, -100px); }
}

.hex-grid {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='49' viewBox='0 0 28 49'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%2300e6ac' fill-opacity='0.02'%3E%3Cpath d='M13.99 9.25l13 7.5v15l-13 7.5L1 31.75v-15l12.99-7.5zM3 17.9v12.7l10.99 6.34 11-6.35V17.9l-11-6.34L3 17.9zM0 15l12.98-7.5V0h-2v6.35L0 12.69v2.3zm0 18.5L12.98 41v8h-2v-6.85L0 35.81v-2.3zM15 0v7.5L27.99 15H28v-2.31h-.01L17 6.35V0h-2zm0 49v-8l12.99-7.5H28v2.31h-.01L17 42.15V49h-2z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.4;
}

.container {
  position: relative;
  z-index: 1;
}

.page-head {
  text-align: center;
  margin-bottom: 40px;
}

.page-head h2 {
  font-size: 32px;
  margin-bottom: 10px;
}

.page-head p {
  color: #888;
  font-size: 16px;
}

.card {
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 16px;
  padding: 40px;
  max-width: 1000px;
  margin: 0 auto;
}

.intro-section {
  margin-bottom: 40px;
  text-align: center;
}

.intro-text {
  font-size: 16px;
  color: #ccc;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
}

.download-section {
  margin-bottom: 50px;
}

.download-section h3 {
  text-align: center;
  font-size: 24px;
  margin-bottom: 30px;
  color: #00e6ac;
}

.download-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.download-card {
  background: rgba(255,255,255,0.02);
  border: 1px solid rgba(255,255,255,0.05);
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  transition: all 0.3s ease;
}

.download-card:hover {
  transform: translateY(-5px);
  border-color: rgba(0,230,172,0.2);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.download-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.download-card h4 {
  font-size: 18px;
  margin-bottom: 10px;
}

.download-card p {
  color: #888;
  font-size: 14px;
  margin-bottom: 20px;
}

.features-section {
  margin-bottom: 50px;
}

.features-section h3 {
  text-align: center;
  font-size: 24px;
  margin-bottom: 30px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.feature-item {
  background: rgba(255,255,255,0.02);
  border: 1px solid rgba(255,255,255,0.05);
  border-radius: 12px;
  padding: 25px;
  text-align: center;
  transition: all 0.3s ease;
}

.feature-item:hover {
  border-color: rgba(0,230,172,0.2);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.feature-icon {
  font-size: 32px;
  margin-bottom: 15px;
}

.feature-item h4 {
  font-size: 16px;
  margin-bottom: 10px;
}

.feature-item p {
  color: #888;
  font-size: 14px;
  line-height: 1.5;
}

.membership-section {
  margin-top: 40px;
}

.membership-card {
  background: linear-gradient(135deg, rgba(0,230,172,0.1), rgba(0,153,255,0.1));
  border: 1px solid rgba(0,230,172,0.2);
  border-radius: 16px;
  padding: 40px;
  text-align: center;
}

.membership-card h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #00e6ac;
}

.membership-text {
  font-size: 16px;
  color: #ccc;
  margin-bottom: 25px;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .card {
    padding: 20px;
  }
  .download-cards {
    grid-template-columns: 1fr;
  }
  .features-grid {
    grid-template-columns: 1fr;
  }
}
</style>